export { UserPanel as LoyaltyUserPanel } from './UserPanel';
